import {
  PageLoading,
  Panel,
  PanelHeading,
  PanelSpacer,
  PanelRow,
  Label,
  BoldText,
  Link,
  PanelDialog,
  StatusIndicator,
} from "@backslashbuild/pp-ui";
import React from "react";
import { useGet } from "./api";
import { isTextNullOrEmpty, utcToLocalText } from "./utils";
import AgencyNewStarterForm from "./AgencyNewStarterForm";
import { subscribe, unsubscribe } from "./pubSub";
import { useAddViewingToHistory } from "../history/api";

export default function AgencyNewStarterPanel({ id }) {
  const [editAgencyDetails, setEditAgencyDetails] = React.useState(null);
  const { data, loading, error, refetch } = useGet(id);
  const addViewingToHistory = useAddViewingToHistory({ itemType: "agency" });

  React.useEffect(() => {
    if (data != null && data.isSuccess) {
      recordViewing();
    }
  }, [id, data?.isSuccess]);

  React.useEffect(() => {
    subscribe("agency.agencyCredit.updated", refetch);
    return () => unsubscribe("agency.agencyCredit.updated", refetch);
  }, [id]);

  if (loading) return <PageLoading />;

  function recordViewing() {
    const fullName = `${data?.value?.name}`;
    const url = `agency/${id}`;

    const body = {
      itemId: id,
      type: "[agency]",
      name: fullName,
      url: url,
    };
    addViewingToHistory(body);
  }

  function handleRender() {
    if (!isTextNullOrEmpty(error)) return <div>{String(error)}</div>;

    if (data != null && !data.isSuccess) {
      return data.errors.map((error) => <div>{error}</div>);
    }

    return (
      <>
        <PanelRow>
          <Label label="New Starter Email Addresses">
            <BoldText>{data?.value?.newStarterEmailAddresses}</BoldText>
          </Label>
        </PanelRow>
        <PanelRow>
          <Label label="New Starter Email Name">
            <BoldText>{data?.value?.newStarterEmailName}</BoldText>
          </Label>
        </PanelRow>
        <PanelRow>
          <Label label="Send Email To Addresses">
            <StatusIndicator value={data?.value?.isSendEmailToAddresses} />
          </Label>
        </PanelRow>
        <PanelRow>
          <Label label="Send Email To Consultant">
            <StatusIndicator value={data?.value?.isSendEmailToConsultant} />
          </Label>
        </PanelRow>
      </>
    );
  }

  return (
    <>
      <Panel>
        <PanelHeading rightAction={<Link onClick={() => setEditAgencyDetails(id)}>Edit</Link>}>
          New Starter Email Details
        </PanelHeading>
        <PanelSpacer />
        {handleRender()}
        <PanelSpacer />
      </Panel>
      <PanelDialog open={editAgencyDetails}>
        <PanelHeading>Edit New Starter Email Details</PanelHeading>
        {editAgencyDetails && (
          <AgencyNewStarterForm id={editAgencyDetails} onClose={() => setEditAgencyDetails(null)} />
        )}
      </PanelDialog>
    </>
  );
}
